import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";
import { PROJECTS } from "@/data/projects";

export default function Footer() {
  const { lang, t } = useLanguage();

  return (
    <footer className="bg-ebony border-t border-bone/10 text-bone" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 md:py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-serif text-2xl font-semibold tracking-tight">
            Hallomedics<span className="text-terracotta">.</span>
          </div>
          <p className="mt-4 text-sm font-light italic text-bone/60 max-w-xs">{t.footer.tagline}</p>
          <p className="mt-6 text-xs uppercase tracking-[0.25em] text-bone/40" data-testid="footer-location">{t.footer.location}</p>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.3em] text-ochre mb-5">{t.footer.venturesTitle}</p>
          <ul className="space-y-2.5">
            {PROJECTS.map((p) => (
              <li key={p.slug}>
                <Link
                  to={`/${lang}/ventures/${p.slug}`}
                  data-testid={`footer-link-${p.slug}`}
                  className="text-sm font-light text-bone/70 hover:text-ochre transition-colors duration-300"
                >
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.3em] text-ochre mb-5">KEDE</p>
          <p className="font-serif text-3xl font-light tracking-tight text-bone">Kenya <span className="italic text-terracotta">/</span> Denmark</p>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs font-light text-bone/40">
          <span>© {new Date().getFullYear()} Hallomedics · KEDE</span>
          <span>{t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
}
